import React from 'react';
import { NavLink } from 'react-router-dom';

const AddPerformanceReviewCrumb = () => (
  <NavLink to="/human-resources/performance-reviews/add">Add Performance Review</NavLink>
);

export default AddPerformanceReviewCrumb;
